import { Injectable } from '@angular/core';
import { SessionAwareMultiStore } from '../../../../shared/stores/session-aware-store';
import { Employee, PermissionGroup } from '../models/employee';
import { SessionAwareSingleStore } from '../../../../shared/stores/session-aware-store';

@Injectable({ providedIn: 'root' })
export class EmployeesStore extends SessionAwareMultiStore<Employee> {}

@Injectable({ providedIn: 'root' })
export class PermissionGroupsStore extends SessionAwareMultiStore<PermissionGroup> {}

@Injectable({ providedIn: 'root' })
export class GrantablePermissionsStore extends SessionAwareSingleStore<string[]> {}
